var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fire"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.61584 4.99611L4.61585 4.99611L6.22556 6.23628L6.29324 6.28843L6.32244 6.20813L8.08883 1.35047C8.1124 1.28565 8.15097 1.22732 8.20138 1.18024C8.25179 1.13317 8.31261 1.09868 8.37889 1.07959C8.44517 1.0605 8.51502 1.05735 8.58275 1.0704C8.65048 1.08345 8.71416 1.11233 8.7686 1.15468L8.76861 1.15469C8.86222 1.22747 10.031 2.14978 11.1758 3.63768C12.3212 5.12633 13.4375 7.1744 13.4375 9.50001C13.4375 10.9421 12.8646 12.3252 11.8449 13.3449C10.8252 14.3646 9.44211 14.9375 8 14.9375C6.55789 14.9375 5.17484 14.3646 4.15511 13.3449C3.13538 12.3252 2.5625 10.9421 2.5625 9.50001C2.5625 8.06319 3.03792 6.58554 3.97992 5.10751L3.92722 5.07392L3.97992 5.10751C4.01256 5.0563 4.05551 5.01244 4.10602 4.97873C4.15654 4.94502 4.21352 4.9222 4.27334 4.91172C4.33316 4.90124 4.39451 4.90334 4.45347 4.91786C4.51244 4.93239 4.56774 4.95904 4.61584 4.99611Z",
    fill: "url(#paint0_linear_3476_378)",
    stroke: "url(#paint1_linear_3476_378)",
    strokeWidth: 0.125
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3476_378",
    x1: 8,
    y1: 1,
    x2: 8,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC601"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1F1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3476_378",
    x1: 8,
    y1: 1,
    x2: 8,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC601"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1F1F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.87550bb726a89aa4010e1f2388431f1c.svg";
export { ForwardRef as ReactComponent };